(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tyga-card-availability"] && !Shopify.designMode) return;
  try {
    (function () {

  const BADGE_SELECTOR =
    '[data-tyga-availability-badge]';


  const DELIVERY_SELECTOR =
    '[data-tyga-delivery-estimate]';

  /* =====================================================
     LIVE PRODUCT VARIANT AVAILABILITY
  ===================================================== */

  if (!window.__tygaAvailabilityVariantListener) {

    window.__tygaAvailabilityVariantListener = true;

    document.addEventListener(
      'shopify:product:select',
      function (event) {

        /*
          Product cards deliberately use overall product
          availability, so don't live-update those here.
        */

        if (
          event.target instanceof Element &&
          (
            event.target.closest('product-card') ||
            event.target.closest('quick-add-dialog')
          )
        ) {
          return;
        }


        if (
          !event.promise ||
          typeof event.promise.then !== 'function'
        ) {
          return;
        }


        event.promise
          .then(function (result) {

            const html =
              result &&
              result.detail &&
              result.detail.html;


            if (
              !html ||
              !html.querySelectorAll
            ) {
              return;
            }


            const freshWrappers =
              Array.from(
                html.querySelectorAll(
                  '[data-tyga-availability-live]'
                )
              );


            document
              .querySelectorAll(
                '[data-tyga-availability-live]'
              )
              .forEach(
                function (currentWrapper) {

                  /*
                    Don't alter collection/recommendation cards.
                  */

                  if (
                    currentWrapper.closest(
                      'product-card'
                    )
                  ) {
                    return;
                  }


                  const blockId =
                    currentWrapper.dataset
                      .tygaAvailabilityLive;


                  const freshWrapper =
                    freshWrappers.find(
                      function (candidate) {

                        return (
                          candidate.dataset
                            .tygaAvailabilityLive ===
                          blockId &&
                          !candidate.closest(
                            'product-card'
                          )
                        );

                      }
                    );


                  if (!freshWrapper) {
                    return;
                  }


                  currentWrapper.replaceWith(
                    freshWrapper.cloneNode(true)
                  );

                }
              );

          })
          .catch(function () {
            /* Theme handles failed variant requests. */
          });

      }
    );

  }
  /* =====================================================
     CURRENT TIME IN TIMEZONE
  ===================================================== */

  function getCurrentTimeParts(timeZone) {

    const formatter =
      new Intl.DateTimeFormat(
        'en-GB',
        {
          timeZone: timeZone,

          year: 'numeric',
          month: '2-digit',
          day: '2-digit',

          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',

          hourCycle: 'h23'
        }
      );


    const parts =
      formatter.formatToParts(
        new Date()
      );


    const values = {};


    parts.forEach(function (part) {

      if (part.type !== 'literal') {

        values[part.type] =
          Number(part.value);

      }

    });


    return values;

  }


  /* =====================================================
     CALENDAR DATE
  ===================================================== */

  function createCalendarDate(
    year,
    month,
    day
  ) {

    return new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        12,
        0,
        0
      )
    );

  }


  function addDay(date) {

    return new Date(
      date.getTime() +
      86400000
    );

  }


  /* =====================================================
     WEEKDAY
     MONDAY = 1
     SUNDAY = 7
  ===================================================== */

  function getWeekday(date) {

    const day =
      date.getUTCDay();


    return day === 0
      ? 7
      : day;

  }


  /* =====================================================
     PARSE DAYS
  ===================================================== */

  function parseDays(value) {

    return String(value || '')
      .split(',')
      .map(function (day) {

        return Number(
          day.trim()
        );

      })
      .filter(function (day) {

        return (
          Number.isInteger(day) &&
          day >= 1 &&
          day <= 7
        );

      });

  }


  /* =====================================================
     FIND NEXT ALLOWED DATE
  ===================================================== */

  function findNextAllowedDate(
    startDate,
    allowedDays
  ) {

    let date =
      startDate;


    for (
      let attempts = 0;
      attempts < 14;
      attempts++
    ) {

      date =
        addDay(date);


      if (
        allowedDays.includes(
          getWeekday(date)
        )
      ) {

        return date;

      }

    }


    return startDate;

  }


  /* =====================================================
     DELIVERY DATE
  ===================================================== */

  function calculateDeliveryDate(
    dispatchDate,
    transitDays,
    deliveryDays
  ) {

    let date =
      dispatchDate;


    let daysAdded =
      0;


    let attempts =
      0;


    while (
      daysAdded < transitDays &&
      attempts < 30
    ) {

      date =
        addDay(date);


      attempts++;


      if (
        deliveryDays.includes(
          getWeekday(date)
        )
      ) {

        daysAdded++;

      }

    }


    return date;

  }


  /* =====================================================
     FORMATTING
  ===================================================== */

 function formatDeliveryDate(
  date,
  today
) {

  const difference =
    Math.round(
      (
        date.getTime() -
        today.getTime()
      ) /
      86400000
    );

  if (difference === 1) {
    return 'Tomorrow';
  }

  return new Intl.DateTimeFormat(
    'en-GB',
    {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    }
  ).format(date);

}


  function formatCollectionWeekday(date) {

    return new Intl.DateTimeFormat(
      'en-GB',
      {
        weekday: 'short',
        timeZone: 'UTC'
      }
    ).format(date);

  }


  /* =====================================================
     COLLECTION
  ===================================================== */

  function calculateCollectionDate(
    today,
    currentMinutes,
    collectionDays,
    collectionCutoffMinutes
  ) {

    const todayIsCollectionDay =
      collectionDays.includes(
        getWeekday(today)
      );


    const beforeCollectionCutoff =
      currentMinutes <
      collectionCutoffMinutes;


    if (
      todayIsCollectionDay &&
      beforeCollectionCutoff
    ) {

      return today;

    }


    return findNextAllowedDate(
      today,
      collectionDays
    );

  }


 function formatCollectionText(
  collectionDate,
  today
) {

  const difference =
    Math.round(
      (
        collectionDate.getTime() -
        today.getTime()
      ) /
      86400000
    );


  if (difference === 0) {

    return 'Today';

  }


  if (difference === 1) {

    return 'Tomorrow';

  }


  return new Intl.DateTimeFormat(
    'en-GB',
    {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    }
  ).format(collectionDate);

}


  /* =====================================================
     NEXT VALID DISPATCH CUTOFF
  ===================================================== */

  function getNextDispatchCutoff(
    now,
    dispatchDays,
    cutoffHour,
    cutoffMinute
  ) {

    if (!dispatchDays.length) {
      return null;
    }


    const today =
      createCalendarDate(
        now.year,
        now.month,
        now.day
      );


    const currentSeconds =
      (now.hour * 3600) +
      (now.minute * 60) +
      now.second;


    const cutoffSeconds =
      (cutoffHour * 3600) +
      (cutoffMinute * 60);


    const todayIsDispatchDay =
      dispatchDays.includes(
        getWeekday(today)
      );


    /*
      If today is a dispatch day and the cutoff
      has not yet passed, use today's cutoff.
    */

    if (
      todayIsDispatchDay &&
      currentSeconds < cutoffSeconds
    ) {

      return {
        date: today,
        daysAway: 0,
        cutoffSeconds: cutoffSeconds
      };

    }


    /*
      Otherwise find the next enabled dispatch day.
    */

    let targetDate =
      today;


    for (
      let daysAway = 1;
      daysAway <= 14;
      daysAway++
    ) {

      targetDate =
        addDay(targetDate);


      if (
        dispatchDays.includes(
          getWeekday(targetDate)
        )
      ) {

        return {
          date: targetDate,
          daysAway: daysAway,
          cutoffSeconds: cutoffSeconds
        };

      }

    }


    return null;

  }


  /* =====================================================
     COUNTDOWN FORMAT
  ===================================================== */

  function formatCountdown(totalSeconds) {

    totalSeconds =
      Math.max(
        0,
        Math.floor(totalSeconds)
      );


    const days =
      Math.floor(
        totalSeconds / 86400
      );


    const hours =
      Math.floor(
        (totalSeconds % 86400) /
        3600
      );


    const minutes =
      Math.floor(
        (totalSeconds % 3600) /
        60
      );


    const seconds =
      totalSeconds % 60;


    /*
      1 day or more:
      1d 22h

      Under 1 day:
      5h 34m

      Under 1 hour:
      42m 18s

      Under 1 minute:
      38s
    */

    if (days > 0) {

      return (
        days +
        'd ' +
        hours +
        'h'
      );

    }


    if (hours > 0) {

      return (
        hours +
        'h ' +
        String(minutes).padStart(2, '0') +
        'm'
      );

    }


    if (minutes > 0) {

      return (
        minutes +
        'm ' +
        String(seconds).padStart(2, '0') +
        's'
      );

    }


    return seconds + 's';

  }


  /* =====================================================
     ACTIVE MESSAGE MANAGEMENT
  ===================================================== */

  function getVisibleMessages(badge) {

    return Array.from(
      badge.querySelectorAll(
        '[data-tyga-availability-message]'
      )
    ).filter(
      function (message) {

        return !message.hidden;

      }
    );

  }


  function ensureValidActiveMessage(badge) {

    const messages =
      getVisibleMessages(badge);


    if (!messages.length) {
      return;
    }


    const active =
      messages.find(
        function (message) {

          return message.classList.contains(
            'is-active'
          );

        }
      );


    if (active) {
      return;
    }


    badge
      .querySelectorAll(
        '[data-tyga-availability-message]'
      )
      .forEach(
        function (message) {

          message.classList.remove(
            'is-active'
          );

          message.setAttribute(
            'aria-hidden',
            'true'
          );

        }
      );


    messages[0].classList.add(
      'is-active'
    );


    messages[0].setAttribute(
      'aria-hidden',
      'false'
    );

  }


  /* =====================================================
     ROTATOR
  ===================================================== */

  function initialiseRotator(
    badge,
    interval
  ) {

    if (
      badge.dataset.tygaRotatorReady === 'true'
    ) {
      return;
    }


    const rotator =
      badge.querySelector(
        '[data-tyga-availability-rotator]'
      );


    if (!rotator) {
      return;
    }


    badge.dataset.tygaRotatorReady =
      'true';


    window.setInterval(
      function () {

        if (
          document.hidden ||
          !document.documentElement.contains(
            badge
          )
        ) {
          return;
        }


        const messages =
          getVisibleMessages(
            badge
          );


        if (messages.length <= 1) {
          return;
        }


        let currentIndex =
          messages.findIndex(
            function (message) {

              return message.classList.contains(
                'is-active'
              );

            }
          );


        if (currentIndex < 0) {
          currentIndex = 0;
        }


        const currentMessage =
  messages[currentIndex];


let nextIndex =
  currentIndex + 1;


if (
  nextIndex >=
  messages.length
) {

  nextIndex = 0;

}


const nextMessage =
  messages[nextIndex];


if (
  currentMessage ===
  nextMessage
) {
  return;
}


currentMessage.classList.remove(
  'is-active'
);

currentMessage.setAttribute(
  'aria-hidden',
  'true'
);


nextMessage.classList.add(
  'is-active'
);

nextMessage.setAttribute(
  'aria-hidden',
  'false'
);

      },

      Math.max(
        2000,
        interval
      )
    );

  }


  /* =====================================================
     RENDER DELIVERY
  ===================================================== */

  function renderDelivery(
    badge,
    now
  ) {

    const output =
      badge.querySelector(
        '.tyga-card-availability__delivery-date'
      );


    if (!output) {
      return;
    }


    const cutoffHour =
      Number(
        badge.dataset.cutoffHour ||
        14
      );


    const cutoffMinute =
      Number(
        badge.dataset.cutoffMinute ||
        0
      );


    const transitDays =
      Math.max(
        1,
        Number(
          badge.dataset.transitDays ||
          1
        )
      );


    const dispatchDays =
      parseDays(
        badge.dataset.dispatchDays
      );


    const deliveryDays =
      parseDays(
        badge.dataset.deliveryDays
      );


    if (
      !dispatchDays.length ||
      !deliveryDays.length
    ) {
      return;
    }


    const today =
      createCalendarDate(
        now.year,
        now.month,
        now.day
      );


    const currentMinutes =
      (now.hour * 60) +
      now.minute;


    const cutoffMinutes =
      (cutoffHour * 60) +
      cutoffMinute;


    const todayIsDispatchDay =
      dispatchDays.includes(
        getWeekday(today)
      );


    const beforeCutoff =
      currentMinutes <
      cutoffMinutes;


    let dispatchDate =
      today;


    if (
      !todayIsDispatchDay ||
      !beforeCutoff
    ) {

      dispatchDate =
        findNextAllowedDate(
          today,
          dispatchDays
        );

    }


    const deliveryDate =
      calculateDeliveryDate(
        dispatchDate,
        transitDays,
        deliveryDays
      );


    output.textContent =
  formatDeliveryDate(
    deliveryDate,
    today
  );

  }


  /* =====================================================
     RENDER COLLECTION
  ===================================================== */

  function renderCollection(
    badge,
    now
  ) {

    const collectionEnabled =
      badge.dataset.collectionEnabled ===
      'true';


    const collectionOutput =
      badge.querySelector(
        '.tyga-card-availability__collection-text'
      );


    const collectionMessage =
      badge.querySelector(
        '[data-tyga-availability-message="collection"]'
      );


    if (
      !collectionEnabled ||
      !collectionOutput ||
      !collectionMessage
    ) {
      return;
    }


    const collectionDays =
      parseDays(
        badge.dataset.collectionDays
      );


    if (!collectionDays.length) {

      collectionMessage.hidden = true;

      ensureValidActiveMessage(
        badge
      );

      return;
    }


    const collectionCutoffHour =
      Number(
        badge.dataset.collectionCutoffHour ||
        17
      );


    const collectionCutoffMinute =
      Number(
        badge.dataset.collectionCutoffMinute ||
        0
      );


    const collectionCutoffMinutes =
      (collectionCutoffHour * 60) +
      collectionCutoffMinute;


    const currentMinutes =
      (now.hour * 60) +
      now.minute;


    const today =
      createCalendarDate(
        now.year,
        now.month,
        now.day
      );


    const collectionDate =
      calculateCollectionDate(
        today,
        currentMinutes,
        collectionDays,
        collectionCutoffMinutes
      );


    const nextCollectionText =
  formatCollectionText(
    collectionDate,
    today
  );

if (
  collectionOutput.textContent !==
  nextCollectionText
) {
  collectionOutput.textContent =
    nextCollectionText;
}


    collectionMessage.hidden =
      false;

  }


  /* =====================================================
     RENDER ORDER COUNTDOWN

     ALWAYS COUNTS TO NEXT VALID DISPATCH CUTOFF
  ===================================================== */

  function renderCountdown(
    badge,
    now
  ) {

    const countdownEnabled =
      badge.dataset.countdownEnabled ===
      'true';


    const countdownMessage =
      badge.querySelector(
        '[data-tyga-availability-message="countdown"]'
      );


    const countdownOutput =
      badge.querySelector(
        '[data-tyga-countdown]'
      );


    if (
      !countdownEnabled ||
      !countdownMessage ||
      !countdownOutput
    ) {
      return;
    }


    const dispatchDays =
      parseDays(
        badge.dataset.dispatchDays
      );


    if (!dispatchDays.length) {

      countdownMessage.hidden =
        true;

      ensureValidActiveMessage(
        badge
      );

      return;
    }


    const cutoffHour =
      Number(
        badge.dataset.cutoffHour ||
        14
      );


    const cutoffMinute =
      Number(
        badge.dataset.cutoffMinute ||
        0
      );


    const target =
      getNextDispatchCutoff(
        now,
        dispatchDays,
        cutoffHour,
        cutoffMinute
      );


    if (!target) {

      countdownMessage.hidden =
        true;

      ensureValidActiveMessage(
        badge
      );

      return;
    }


    const currentSeconds =
      (now.hour * 3600) +
      (now.minute * 60) +
      now.second;


    /*
      Calculate remaining time using whole
      calendar days plus the local cutoff time.

      Example:
      Saturday 3pm -> Monday 2pm
      = 1 day 23 hours.
    */

    const remainingSeconds =
      (
        target.daysAway *
        86400
      ) +
      target.cutoffSeconds -
      currentSeconds;


    countdownMessage.hidden =
      false;


    const nextCountdownText =
  formatCountdown(
    remainingSeconds
  );

if (
  countdownOutput.textContent !==
  nextCountdownText
) {
  countdownOutput.textContent =
    nextCountdownText;
}

  }


  /* =====================================================
     INITIALISE ONE BADGE
  ===================================================== */

  function initialiseBadge(badge) {

    if (
      badge.dataset.tygaDeliveryReady ===
      'true'
    ) {
      return;
    }


    const isDeliveryBadge =
      badge.matches(
        DELIVERY_SELECTOR
      );


    if (isDeliveryBadge) {

      const timeZone =
        badge.dataset.timeZone ||
        'Europe/London';


      const now =
        getCurrentTimeParts(
          timeZone
        );


      renderDelivery(
        badge,
        now
      );


      renderCountdown(
        badge,
        now
      );


      renderCollection(
        badge,
        now
      );


      badge.dataset.tygaDayKey =
        now.year +
        '-' +
        now.month +
        '-' +
        now.day;


      const cutoffHour =
        Number(
          badge.dataset.cutoffHour ||
          14
        );


      const cutoffMinute =
        Number(
          badge.dataset.cutoffMinute ||
          0
        );


      const currentMinutes =
        (now.hour * 60) +
        now.minute;


      const cutoffMinutes =
        (cutoffHour * 60) +
        cutoffMinute;


      badge.dataset.tygaCutoffState =
        currentMinutes <
        cutoffMinutes
          ? 'before'
          : 'after';

    }


    ensureValidActiveMessage(
      badge
    );


    const rotationInterval =
      Number(
        badge.dataset.rotationInterval ||
        3000
      );


    initialiseRotator(
      badge,
      rotationInterval
    );


    badge.dataset.tygaDeliveryReady =
      'true';

  }


  /* =====================================================
     INITIALISE ALL
  ===================================================== */

  function initialiseAll(root) {

    if (
      root instanceof Element &&
      root.matches(BADGE_SELECTOR)
    ) {

      initialiseBadge(
        root
      );

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          BADGE_SELECTOR
        )
        .forEach(
          initialiseBadge
        );

    }

  }


  initialiseAll(
    document
  );


  /* =====================================================
     LIVE UPDATES
  ===================================================== */

  window.setInterval(
    function () {

      const badges =
        document.querySelectorAll(
          DELIVERY_SELECTOR
        );


      const timeCache = {};


      badges.forEach(
        function (badge) {

          const timeZone =
            badge.dataset.timeZone ||
            'Europe/London';


          if (
            !timeCache[timeZone]
          ) {

            timeCache[timeZone] =
              getCurrentTimeParts(
                timeZone
              );

          }


          const now =
            timeCache[timeZone];


          const dayKey =
            now.year +
            '-' +
            now.month +
            '-' +
            now.day;


          const previousDayKey =
            badge.dataset.tygaDayKey;


          /*
            Countdown refreshes every second.
          */

          renderCountdown(
            badge,
            now
          );


          /*
            Collection is also time-sensitive
            because of the 5pm cutoff.
          */

          renderCollection(
            badge,
            now
          );


          /*
            Refresh delivery at midnight.
          */

          if (
            previousDayKey !==
            dayKey
          ) {

            renderDelivery(
              badge,
              now
            );


            badge.dataset.tygaDayKey =
              dayKey;

          }


          /*
            Refresh delivery when today's
            2pm dispatch cutoff is crossed.
          */

          const cutoffHour =
            Number(
              badge.dataset.cutoffHour ||
              14
            );


          const cutoffMinute =
            Number(
              badge.dataset.cutoffMinute ||
              0
            );


          const currentMinutes =
            (now.hour * 60) +
            now.minute;


          const cutoffMinutes =
            (cutoffHour * 60) +
            cutoffMinute;


          const cutoffState =
            currentMinutes <
            cutoffMinutes
              ? 'before'
              : 'after';


          if (
            badge.dataset.tygaCutoffState !==
            cutoffState
          ) {

            renderDelivery(
              badge,
              now
            );


            badge.dataset.tygaCutoffState =
              cutoffState;

          }

        }
      );

    },

    1000
  );


  /* =====================================================
     DYNAMIC COLLECTION CARDS / FILTERS
  ===================================================== */

  const observer =
    new MutationObserver(
      function (mutations) {

        mutations.forEach(
          function (mutation) {

            mutation.addedNodes.forEach(
              function (node) {

                if (
                  node.nodeType !== 1
                ) {
                  return;
                }


                initialiseAll(
                  node
                );

              }
            );

          }
        );

      }
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
